import React, { useState } from 'react';
import SelectField from '../../Forms/Input/SelectField';
import InputField from '../../Forms/Input/InputField';
import SvgIcon from '../../SvgIcon/SvgIcon';

interface BranchOption {
  id: number;
  name: string;
}

interface Props {
  branches: BranchOption[];
  onSettle: (branchId: number, quantity: number) => void;
}

const ProductSettlementFormCard: React.FC<Props> = ({ branches, onSettle }) => {
  const [selectedBranchId, setSelectedBranchId] = useState<number | ''>('');
  const [quantity, setQuantity] = useState('');
  const [errors, setErrors] = useState<{ branchId?: string; quantity?: string }>({});

  const handleSubmit = () => {
    const newErrors: typeof errors = {};

    if (!selectedBranchId) {
      newErrors.branchId = 'Debe seleccionar una sucursal';
    }

    if (!quantity || Number(quantity) <= 0) {
      newErrors.quantity = 'Debe ingresar una cantidad válida';
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    setErrors({});
    onSettle(Number(selectedBranchId), Number(quantity));
  };

  return (
    <div className="rounded border border-stroke bg-white p-4 shadow dark:border-strokedark dark:bg-boxdark">
      <h3 className="mb-4 text-lg font-semibold text-black dark:text-white">
        Asentar Producto Manualmente
      </h3>

      <div className="space-y-4">
        <SelectField
          label="Sucursal"
          name="branchId"
          iconKey="list"
          value={selectedBranchId}
          onChange={(e) => setSelectedBranchId(Number(e.target.value))}
          options={branches.map((branch) => ({
            value: branch.id,
            label: branch.name,
          }))}
          required
          error={errors.branchId}
        />

        <InputField
          label="Cantidad a Asentar"
          name="quantity"
          type="number"
          value={quantity}
          min={0}
          onChange={(e) => setQuantity(e.target.value)}
          iconKey="product"
          required
          error={errors.quantity}
        />
      </div>

      <div className="mt-6 flex justify-end">
        <button
          type="button"
          onClick={handleSubmit}
          className="flex items-center justify-center gap-2 rounded bg-primary px-4.5 py-2.5 font-medium text-white hover:bg-opacity-90"
        >
          <SvgIcon name="plus" className="h-5 w-5" />
          Asentar Producto
        </button>
      </div>
    </div>
  );
};

export default ProductSettlementFormCard;
